// extracted by mini-css-extract-plugin
export default {"playersContainer":"PlayersEndScreen_playersContainer__q0kya"};